<template>
    <label class="orientationToggle">
        <input type="checkbox" :checked="orientationValue == 'vertical'" @click.prevent="toggleOrientationSetting">
        <span>Vertical</span>
    </label>
</template>

<script>
import axios from "axios"

export default {
    name: 'OrientationToggle',
    methods: {
        toggleOrientationSetting() {
            let value = 'normal'
            if (this.orientationValue == 'normal') {
                value = 'vertical'
            }
            axios.post(`${process.env.VUE_APP_BACKEND_URL}/settings`, {
                name: 'orientation', value
            });
        },
    },
    computed: {
        orientationSetting() {
            return this.$store.getters['settings/name']('orientation')
        },
        orientationValue() {
            if (this.orientationSetting == null) {
                return 'normal'
            }
            return this.orientationSetting.value
        },
    },
    mounted() {
        this.$store.dispatch('settings/fetch', 'orientation')
    },
}
</script>

<style lang="scss" scoped>
.orientationToggle {
    display: flex;
    align-items: center;
    gap: .5rem;
    cursor: pointer;
}
</style>
